import { PATHS } from 'commons/paths';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import LoadingModal from 'organisms/LoadingModal';
import { AuthenticatedQuestionnaire } from 'organisms/u002/questionnaire/AuthenticatedQuestionnaire';

/**
 * アンケートURLのエントリポイント
 * ※URLから取得した審査Noが2以上の場合にアンケートとしてこちらのフローに入る。
 */
export const Questionnaire: FC = () => {
  const auth = useAuth();

  if (auth.isLoading) return <LoadingModal />;

  //2-1.ログイン済みであれば次の2-2へ。未ログインであればログイン画面へ遷移する。ログインが完了したら、2-2へ遷移する。
  if (!auth.isAuthenticated) {
    return <RedirectLogin />;
  }

  return <AuthenticatedQuestionnaire />;
};

/**
 * ログイン画面へ遷移させ、ログイン完了後に元のURLにリダイレクトする
 */
const RedirectLogin: FC = () => {
  const nav = useNavigate();
  useEffect(() => {
    const toParam = new URLSearchParams();
    toParam.set('redirect', window.location.pathname);
    const to = PATHS.LOGIN + '?' + toParam.toString();
    nav(to);
  }, []);
  return <></>;
};
